<template src="./template.html"></template>

<script>
import { Fragment } from 'vue-fragment'

import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import SubmitButton from '@/components/Button/index.vue'
import LocationFormInput from '@/components/Form/Input/index.vue'
import LocationForm from '@/components/Form/index.vue'
import LoadingSpinner from '@/components/LoadingSpinner'
import SectionHeader from '@/components/SectionHeader'
import DumpingStationTable from '@/components/Table/index.vue'
import CompanyNav from '@/components/company_nav'
import GeoCoder from '@/components/geocoder'

import locationsApi from '@/api/locations'

export default {
  name: 'new_company_location',
  inject: ['companyUser'],
  data: () => ({
    company: {},
    loading: true,
    location: {},
    templateMode: 'add',
  }),
  components: {
    BreadCrumbs,
    CompanyNav,
    DumpingStationTable,
    Fragment,
    GeoCoder,
    LoadingSpinner,
    LocationForm,
    LocationFormInput,
    SectionHeader,
    SubmitButton,
  },
  methods: {
    async onFormSubmitted() {
      await this.createLocation()
    },
    async createLocation() {
      if (await locationsApi.create(this.location)) {
        await this.$router.push('/company')
      }
    },
    getCoordinates(value) {
      this.location.lat = value[1]
      this.location.lng = value[0]
    },
  },
  async mounted() {
    this.location.company_uuid = this.companyUser.company_uuid
    this.loading = false
  },
}
</script>
